import { useCallback } from 'react';
import { darkTheme } from '~/_shared/themes/dark.theme';
import { lightTheme } from '~/_shared/themes/light.theme';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { useLogOutUser } from '~/authorization/logOutUser.hook';
import { MobileFooterComponent } from '~/homepage/mobile/mobileFooterComponent';
import { useUpdateUserTheme } from '~/store/theme/useUpdateUserTheme.hook';

export const MobileFooterContainer = () => {
  const theme = useTheme();
  const logOutUser = useLogOutUser();
  const { updateUserTheme, themeChangeAllowed } = useUpdateUserTheme();

  const onThemeChange = useCallback((isDarkTheme: boolean) => {
    updateUserTheme(isDarkTheme ? darkTheme.name : lightTheme.name);
  }, [updateUserTheme]);

  return (
    <MobileFooterComponent
      currentTheme={theme.name}
      onLogOut={logOutUser}
      onThemeChange={themeChangeAllowed ? onThemeChange : undefined}
    />
  );
};
